import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// -----------------------------
// ASYNC THUNKS
// -----------------------------

export const loadMentors = createAsyncThunk(
    "mentors/loadMentors",
    async ({ request, user_id, role_id, domains }, { rejectWithValue }) => {
        try {
            const url =
                API.LOAD_MENTORS +
                "/" +
                user_id +
                "/" +
                role_id +
                "?userDomains=" +
                domains;

            const response = await agent.get(url, {
                params: request,
            });

            const result = response.data?.data;

            return {
                mentors: result?.data || [],
                pagination: result?.pagination || null,
                hasData: result?.data?.length > 0,
            };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const saveSelectMentor = createAsyncThunk(
    "mentors/saveSelectMentor",
    async (params, { rejectWithValue }) => {
        try {
            const response = await agent.post(API.SAVESELECTMENTOR, params);
            return response.data?.message;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Error selecting mentor");
        }
    }
);

export const getFilterData = createAsyncThunk(
    "mentors/getFilterData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.GET_FILTER);
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Failed to load filters");
        }
    }
);

// -----------------------------
// SLICE
// -----------------------------

const menteeListingSlice = createSlice({
    name: "menteeListing",
    initialState: {
        mentorsData: [],
        filters: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // Load mentors
            .addCase(loadMentors.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadMentors.fulfilled, (state, action) => {
                state.loading = false;
                state.mentorsData = Array.isArray(action.payload.mentors)
                    ? action.payload.mentors
                    : [];
            })
            .addCase(loadMentors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Select mentor
            .addCase(saveSelectMentor.fulfilled, (state) => { })

            // Filters
            .addCase(getFilterData.fulfilled, (state, action) => {
                state.filters = action.payload;
            });
    },
});

export default menteeListingSlice.reducer;
